import { Injectable } from '@angular/core';
import { DrLocales } from '@app/core/services/i18n/i18n.service';
import { AbstractStorageKey, StorageKey, AdvancedStorageKey } from './storage-key';
import { User } from '../../../shared/models/user';
import { ColDef } from 'ag-grid-community';

@Injectable({
  providedIn: 'root'
})
export class DrLocalStorageService {

  private prefix = 'SMP360_';
  public readonly STORAGE_KEY_LOCALE: StorageKey<DrLocales> = new StorageKey<DrLocales>(`${this.prefix}STORAGE_KEY_LOCALE`);
  public readonly STORAGE_KEY_USER: AdvancedStorageKey<User> = new AdvancedStorageKey<User>(`${this.prefix}STORAGE_KEY_USER`, User);
  public readonly STORAGE_KEY_INBOX_COLUMN_STATE: StorageKey<ColDef[]> = new StorageKey<ColDef[]>(`${this.prefix}STORAGE_KEY_INBOX_COLUMN_STATE`);
  public readonly STORAGE_KEY_CASE_COLUMN_STATE: StorageKey<ColDef[]> = new StorageKey<ColDef[]>(`${this.prefix}STORAGE_KEY_CASE_COLUMN_STATE`);


  constructor() { }

  public set<T>(storageKey: AbstractStorageKey<T>, value: T): void {
      localStorage.setItem(storageKey.key, JSON.stringify(value));
  }

  public get<T>(storageKey: AbstractStorageKey<T>): T | null {
      const localStarageItem = localStorage.getItem(storageKey.key);

      if (localStarageItem) {
        return storageKey.parseFromJSON(localStarageItem);
      }

      return null;
  }

  public remove<T>(storageKey: AbstractStorageKey<T>): void {
    localStorage.removeItem(storageKey.key);
  }
}
